module.exports = __webpack_public_path__ + "static/data-platform-50d3bbbd2c3c9802a3212edd221f5e0a.svg";